import { connect } from 'react-redux';

import type { ReduxApplicationState } from 'src/redux/combinedReducer';
import { Tree } from '../components/FilterOptions/Tree';
import {
  selectChildNodes,
  selectParentNodes,
  selectRouterPathWithoutCurrentFilter,
} from '../modules/selectors/treeSelectors';
import type { TreeContainerOwnProps, TreeContainerStateProps } from './TreeContainer.types';

export const mapStateToProps = (
  state: ReduxApplicationState,
  ownProps: TreeContainerOwnProps,
): TreeContainerStateProps => ({
  // @ts-ignore
  childNodes: selectChildNodes(state, ownProps),
  parentNodes: selectParentNodes(state, ownProps),
  // @ts-ignore
  pathWithoutCurrentFilter: selectRouterPathWithoutCurrentFilter(state, ownProps),
});

export const TreeContainer = connect(mapStateToProps)(Tree);
